import {Box, Button, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import {useQueryClient} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {FiveStarsEnum} from 'main/analytics/gaTagsEnum';
import Image from 'presentation/assets/images/lifestyle-love.svg';
import {HomeEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';

import {ImageContainer, StyledDialog, StyledDialogHeader} from './styles';
import {useRatingModalStore} from '../../stores/useRatingModalStore';

const {finishRating, thanksForRatingDescription, thanksForRatingTitle, rateYourAttendance} =
	translations['pt-br'].privateFlow.fiveStarsRating;

export function FinishEvaluations() {
	const navigate = useNavigate();
	const ratingModal = useRatingModalStore(state => state.ratingModal);
	const setRatingModal = useRatingModalStore(state => state.setRatingModal);
	const queryClient = useQueryClient();

	async function handleGoToHome() {
		await Promise.resolve(setRatingModal('stale'));

		queryClient.resetQueries({queryKey: [QUERY_KEYS.FIVE_STARS]});
		navigate(HomeEnum.HOME_PAGE);
	}

	useEffect(() => {
		if (ratingModal === 'success') {
			const timer = setTimeout(() => {
				handleGoToHome();
			}, 5000);

			return () => clearTimeout(timer);
		}
		return undefined;
	}, [ratingModal]);

	return (
		<StyledDialog
			open={ratingModal === 'success'}
			data-tag-id={FiveStarsEnum.REALIZOU_AVALIACAO_COM_SUCESSO}>
			<StyledDialogHeader>{rateYourAttendance}</StyledDialogHeader>
			<DialogContent>
				<ImageContainer>
					<img
						src={Image}
						alt="Pessoa sentada com as pernas cruzadas e os braços formando um coração acima da cabeça"
						width={140}
						height={140}
					/>
				</ImageContainer>
				<DialogTitle textAlign="center">{thanksForRatingTitle}</DialogTitle>
				<DialogContentText textAlign="center" color="text.primary">
					{thanksForRatingDescription}
				</DialogContentText>
			</DialogContent>
			<Box p={2}>
				<Button fullWidth size="large" onClick={handleGoToHome}>
					{finishRating}
				</Button>
			</Box>
		</StyledDialog>
	);
}
